import { createContext, useContext, useState } from 'react';
import { APIContext } from './APIContext';
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import ValidatedTextField from "../Utilities/Forms/ValidatedTextField";
import Dialog from "@mui/material/Dialog";
import { FormContainer, useForm } from "react-hook-form-mui";
import ContactViewModel from "./ContactViewModel";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Stack from "@mui/material/Stack";
import { SessionContext } from "../Contexts/SessionContext";


type ContextModel = {
    openContactForm: (additionalComments?: string, additionalData?: string) => void;
};

export const ContactFormContext = createContext<ContextModel>({
    openContactForm: () => { throw Error('Cannot use a context without a provider'); },
});

export default function ContactFormContextProvider({ children }: React.PropsWithChildren<{}>) {
    const { saveSession } = useContext(SessionContext);
    const { post, showMessage } = useContext(APIContext);
    const [open, setOpen] = useState(false);
    const [additionalComments, setAdditionalComments] = useState<string | undefined>(undefined);
    const [additionalData, setAdditionalData] = useState<string | undefined>(undefined);

    const formContext = useForm<ContactViewModel>({
        defaultValues: new ContactViewModel(),
    });

    const submit = async (data: ContactViewModel) => {
        data.additional = additionalData ?? '';
        data.url = window.location.href;
        saveSession(`Contact_Form_${new Date().toISOString()}`, "Error", (code) => {
            data.auditCode = code;
            post('Contact', `SendContactEmailToSupport`, data, (response: any) => {
                showMessage("success", "Message sent successfully");
                closeContactForm()
            });
        })
    };

    const initialise = () => {
        formContext.reset(new ContactViewModel());
        setAdditionalComments(undefined);
        setAdditionalData(undefined);
    };
    const openContactForm = async (additionalComments?: string, additionalData?: string) => {
        setAdditionalComments(additionalComments);
        setAdditionalData(additionalData);
        setOpen(true);
    };
    const closeContactForm = async () => {
        initialise();
        setOpen(false);
    };

    const context: ContextModel = {
        openContactForm
    }

    return (
        <ContactFormContext.Provider value={context}>
            {children}

            <Dialog open={open} maxWidth="sm" fullWidth>
                <DialogTitle>
                    <Typography variant={"h5"}>Contact TRICS</Typography>
                </DialogTitle>
                <DialogContent>
                    <FormContainer formContext={formContext} onSuccess={submit}>
                        <Grid container justifyContent="flex-end">
                            {additionalComments &&
                                <Grid size={12}>
                                    <Typography variant="body1">{additionalComments}</Typography>
                                </Grid>
                            }
                            <Grid size={12}>
                                <Typography variant="body1">Comments</Typography>
                            </Grid>
                            <Grid size={12}>
                                <ValidatedTextField name={'comment'} multiline={true} rows={5} />
                            </Grid>
                            <Grid size={6}>
                                <Stack direction="row" spacing={1}>
                                    <Button onClick={closeContactForm} variant="outlined">Cancel</Button>
                                    <Button type="submit">Submit</Button>
                                </Stack>
                            </Grid>
                        </Grid>
                    </FormContainer>
                </DialogContent>
            </Dialog>
        </ContactFormContext.Provider>
    );
}
